const LimitedTokensActionTypes = {
    START_FETCH_AVAILABLE_LIMITED_TOKENS: 'START_FETCH_AVAILABLE_LIMITED_TOKENS',
    SUCCESS_FETCH_AVAILABLE_LIMITED_TOKENS: 'SUCCESS_FETCH_AVAILABLE_LIMITED_TOKENS',
    FINISH_FETCH_AVAILABLE_LIMITED_TOKENS: 'FINISH_FETCH_AVAILABLE_LIMITED_TOKENS',
    FAILURE_FETCH_AVAILABLE_LIMITED_TOKENS: 'FAILURE_FETCH_AVAILABLE_LIMITED_TOKENS',

    START_BUY_LIMITED_TOKENS: 'START_BUY_LIMITED_TOKENS',
    SUCCESS_BUY_LIMITED_TOKENS: 'SUCCESS_BUY_LIMITED_TOKENS',
    FINISH_BUY_LIMITED_TOKENS: 'FINISH_BUY_LIMITED_TOKENS',
    FAILURE_BUY_LIMITED_TOKENS: 'FAILURE_BUY_LIMITED_TOKENS',

    START_TRANSFER_LIMITED_TOKENS: 'START_TRANSFER_LIMITED_TOKENS',
    SUCCESS_TRANSFER_LIMITED_TOKENS: 'SUCCESS_TRANSFER_LIMITED_TOKENS',
    FINISH_TRANSFER_LIMITED_TOKENS: 'FINISH_TRANSFER_LIMITED_TOKENS',
    FAILURE_TRANSFER_LIMITED_TOKENS: 'FAILURE_TRANSFER_LIMITED_TOKENS',

    START_WITHDRAW_LIMITED_TOKENS: 'START_WITHDRAW_LIMITED_TOKENS',
    SUCCESS_WITHDRAW_LIMITED_TOKENS: 'SUCCESS_WITHDRAW_LIMITED_TOKENS',
    FINISH_WITHDRAW_LIMITED_TOKENS: 'FINISH_WITHDRAW_LIMITED_TOKENS',
    FAILURE_WITHDRAW_LIMITED_TOKENS: 'FAILURE_WITHDRAW_LIMITED_TOKENS',

    START_SELL_LIMITED_TOKENS: 'START_SELL_LIMITED_TOKENS',
    SUCCESS_SELL_LIMITED_TOKENS: 'SUCCESS_SELL_LIMITED_TOKENS',
    FINISH_SELL_LIMITED_TOKENS: 'FINISH_SELL_LIMITED_TOKENS',
    FAILURE_SELL_LIMITED_TOKENS: 'FAILURE_SELL_LIMITED_TOKENS',

    START_GET_SELL_LIMITED_TOKENS_FEE: 'START_GET_SELL_LIMITED_TOKENS_FEE',
    SUCCESS_GET_SELL_LIMITED_TOKENS_FEE: 'SUCCESS_GET_SELL_LIMITED_TOKENS_FEE',
    FINISH_GET_SELL_LIMITED_TOKENS_FEE: 'FINISH_GET_SELL_LIMITED_TOKENS_FEE',
    FAILURE_GET_SELL_LIMITED_TOKENS_FEE: 'FAILURE_GET_SELL_LIMITED_TOKENS_FEE',

    START_GET_BUY_LIMITED_TOKENS_FEE: 'START_GET_BUY_LIMITED_TOKENS_FEE',
    SUCCESS_GET_BUY_LIMITED_TOKENS_FEE: 'SUCCESS_GET_BUY_LIMITED_TOKENS_FEE',
    FINISH_GET_BUY_LIMITED_TOKENS_FEE: 'FINISH_GET_BUY_LIMITED_TOKENS_FEE',
    FAILURE_GET_BUY_LIMITED_TOKENS_FEE: 'FAILURE_GET_BUY_LIMITED_TOKENS_FEE',

    START_GET_LIMITED_TOKEN_DETAILS: 'START_GET_LIMITED_TOKEN_DETAILS',
    SUCCESS_GET_LIMITED_TOKEN_DETAILS: 'SUCCESS_GET_LIMITED_TOKEN_DETAILS',
    FINISH_GET_LIMITED_TOKEN_DETAILS: 'FINISH_GET_LIMITED_TOKEN_DETAILS',
    FAILURE_GET_LIMITED_TOKEN_DETAILS: 'FAILURE_GET_LIMITED_TOKEN_DETAILS',

    START_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: 'START_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE',
    SUCCESS_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: 'SUCCESS_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE',
    FINISH_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: 'FINISH_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE',
    FAILURE_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE: 'FAILURE_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE',

    START_REDEEM_LIMITED_TOKENS: 'START_REDEEM_LIMITED_TOKENS',
    SUCCESS_REDEEM_LIMITED_TOKENS: 'SUCCESS_REDEEM_LIMITED_TOKENS',
    FINISH_REDEEM_LIMITED_TOKENS: 'FINISH_REDEEM_LIMITED_TOKENS',
    FAILURE_REDEEM_LIMITED_TOKENS: 'FAILURE_REDEEM_LIMITED_TOKENS',
}

export default LimitedTokensActionTypes
